<div class="grid-wrapper">
  <fpx-ro-grid
  [columnsArray]="columnsArray"
  [tableDatafn]="gridService"
  [title]="title"
  [toolBarConfig]="toolBar"
  (handleActions)="handleActions($event)"
  [refreshGrid$]="refresh$"
  [interceptors]="interceptors"
  [multiRowSelect]="false"
  [initialCriteria]="unpostedTransactiondtlsDisplayGridHelper.initialCriteria"
>
</fpx-ro-grid>
</div>
